/**
 * @description 全局Model tagModel 挂载到 redux 上
 */
import createModel, { Tction } from '@tkit/model';
import { APIS } from '@src/services';
import {
  ParamstagsTagIdUsingGet,
  ParamstagsTagIdLastUsingGet,
  ParamstagsTagIdFollowUsingPost
} from '@src/services/api/TagApi';
import { ParamsquestionQuestionIdCollectUsingPost } from '@src/services/api/QuestionApi';
import * as models from '@services/model/models';
import { message } from 'antd';

export interface State {
  tagInfoModel: any;
  newArticleListModel: models.PageableResultSingleArticleInfo;
  askListModel: models.PageableResultQuestionSimpleInfo;
  answerListModel: models.PageableResultAnswerSimpleInfo;
  newArticleListLoading: boolean;
  askListLoading: boolean;
  answerListLoading: boolean;
}

export const tagModelState: State = {
  tagInfoModel: {},
  newArticleListModel: {},
  askListModel: {},
  answerListModel: {},
  newArticleListLoading: true,
  askListLoading: true,
  answerListLoading: true
};
const model = createModel({
  state: tagModelState,
  namespace: 'tagModel',
  reducers: {
    // 标签信息
    setTagInfo: (state, action: Tction<{ tagInfoModel: any }>) => {
      return {
        ...state,
        tagInfoModel: action.payload.tagInfoModel
      };
    },
    setNewArticleList: (
      state,
      action: Tction<{
        listModel: models.PageableResultSingleArticleInfo;
        listType: number;
      }>
    ) => {
      const { listModel, listType } = action.payload;
      let listKey = '';
      if (listType === 1) {
        listKey = 'newArticleListModel';
      } else if (listType === 2) {
        listKey = 'askListModel';
      } else if (listType === 3) {
        listKey = 'answerListModel';
      }
      // let listModelObj = state[listKey];
      // if (listModelObj && listModelObj.list && type) {
      //   listModelObj.list.push(...(listModel.list || []));
      // } else {
      //   listModelObj = listModel;
      // }
      return {
        ...state,
        [listKey]: listModel
      };
    },
    // 更新关注数量
    updateFollowNum: (state, action: Tction<{ follow: boolean }>) => {
      const { tagInfoModel } = state;
      const follow = action.payload.follow;
      if (follow) {
        tagInfoModel.follower++;
      } else {
        tagInfoModel.follower--;
      }
      return {
        ...state
      };
    },
    // 重置页面数据
    setReset: state => {
      return {
        ...state,
        newArticleListModel: {},
        askListModel: {},
        answerListModel: {}
      };
    },
    // 更新loading状态
    updateLoading: (state, action: Tction<{ key: string; loading: boolean }>) => {
      const { key, loading } = action.payload;
      return {
        ...state,
        [key]: loading
      };
    },
    // 更新问题|回答状态
    updateAskStatus: (state, action: Tction<{ questionIdVal: number; key: string; val: any }>) => {
      const { questionIdVal, key, val } = action.payload;
      const { askListModel } = state;
      const { list } = askListModel;
      if (list) {
        list.map((item: models.QuestionSimpleInfo) => {
          const { questionId } = item;
          if (questionId === questionIdVal) {
            item[key] = val;
          }
        });
      }
      return {
        ...state,
        askListModel
      };
    },
    // 更新问题|回答状态
    updateAnswerStatus: (state, action: Tction<{ answerIdVal: number; key: string; val: any }>) => {
      const { answerIdVal, key, val } = action.payload;
      const { answerListModel } = state;
      const { list } = answerListModel;
      if (list) {
        list.map((item: models.AnswerSimpleInfo) => {
          const { answerId } = item;
          if (answerId === answerIdVal) {
            item[key] = val;
          }
        });
      }
      return {
        ...state,
        answerListModel
      };
    }
  },
  effects: {
    // 标签信息
    *getTagInfo(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamstagsTagIdUsingGet;
        callBack?: (result: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callBack } = action.payload;
      const res = yield tCall(APIS.TagApi.tagsTagIdUsingGet, params);
      if (res.code === 0) {
        yield tPut(model.actions.setTagInfo, { tagInfoModel: res.result || {} });
        callBack && callBack(res);
      }
    },
    // 关注/取关标签
    *tagFollow(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamstagsTagIdFollowUsingPost;
        callBack: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const res = yield tCall(APIS.TagApi.tagsTagIdFollowUsingPost, action.payload.params);
      action.payload.callBack(res);
      if (res.code === 0) {
        const { follow } = action.payload.params;
        yield tPut(model.actions.updateFollowNum, { follow });
      }
    },
    // 获取最新章
    *getNewArticleList(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamstagsTagIdLastUsingGet;
        type?: string;
        callBack?: (num: number) => void;
      }>
    ): Iterator<{}, any, any> {
      let loadingKey = '';
      const listType = action.payload.params.type;
      if (listType === 1) {
        loadingKey = 'newArticleListLoading';
      } else if (listType === 2) {
        loadingKey = 'askListLoading';
      } else if (listType === 3) {
        loadingKey = 'answerListLoading';
      }
      yield tPut(model.actions.updateLoading, {
        key: loadingKey,
        loading: true
      });
      const res = yield tCall(APIS.TagApi.tagsTagIdLastUsingGet, action.payload.params);
      yield tPut(model.actions.updateLoading, {
        key: loadingKey,
        loading: false
      });
      const { code, result } = res;
      const { callBack, type } = action.payload;
      if (code === 0) {
        yield tPut(model.actions.setNewArticleList, { listModel: result, listType });
        callBack && callBack(result.total);
      } else {
        message.error(res.message);
      }
    },
    // 提问关注
    *doFollowHomeQuestion(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsquestionQuestionIdCollectUsingPost;
        callBack?: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const {
        params,
        callBack,
        params: { questionId, type }
      } = action.payload;
      const parmsObj = { questionIdVal: questionId, key: 'isFollowing', val: true };
      yield tPut(model.actions.updateAskStatus, parmsObj);
      const res = yield tCall(APIS.QuestionApi.questionQuestionIdCollectUsingPost, params);
      const { code } = res;
      if (code === 0) {
        yield tPut(model.actions.updateAskStatus, {
          questionIdVal: questionId,
          key: 'hasFollow',
          val: type
        });
      }
      parmsObj.val = false;
      yield tPut(model.actions.updateAskStatus, parmsObj);
      callBack && callBack(res);
    },
    // 回答赞同
    *doAgreeHomeAnswer(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: {
          answerId: number;
          type: number;
        };
        callBack?: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const {
        params,
        callBack,
        params: { answerId, type }
      } = action.payload;
      const parmsObj = { answerIdVal: answerId, key: 'isFollowing', val: true };
      yield tPut(model.actions.updateAnswerStatus, parmsObj);
      const res = yield tCall(APIS.AnswerApi.answerAnswerIdAgreeUsingPost, params);
      const { code, result } = res;
      if (code === 0) {
        // 更新状态
        yield tPut(model.actions.updateAnswerStatus, {
          answerIdVal: answerId,
          key: 'agreeStatus',
          val: type
        });
        // 更新赞同数量
        yield tPut(model.actions.updateAnswerStatus, {
          answerIdVal: answerId,
          key: 'agreeCount',
          val: result.agreeCount
        });
      }
      parmsObj.val = false;
      yield tPut(model.actions.updateAnswerStatus, parmsObj);
      callBack && callBack(res);
    },
    // 重置页面数据
    *reset({ namespace, put, tPut, tCall }): Iterator<{}, any, any> {
      yield tPut(model.actions.setReset);
    }
  }
});

export default model;
